
/**
 * 인증 제공자
 */
export type GetUserById200Provider = typeof GetUserById200Provider[keyof typeof GetUserById200Provider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserById200Provider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
